import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface CardProps {
  className?: string;
  children: ReactNode;
}

export function Card({ className, children }: CardProps) {
  return (
    <div
      className={cn(
        'w-full max-w-md rounded-[var(--radius-card)] border border-border bg-surface',
        'shadow-[var(--shadow-card)] px-6 py-8 sm:px-8 sm:py-10',
        className,
      )}
    >
      {children}
    </div>
  );
}
